import { joinBy } from '@pbk/utils';
export const formatIbanWithSpacesPer4Characters = (iban) => {
    const sanitizedIban = iban.replace(/\s+/g, '');
    const ibanGroups = sanitizedIban.match(/.{1,4}/g);
    const formattedIban = ibanGroups ? joinBy(ibanGroups, ' ') : '';
    return formattedIban;
};
